module.exports = __webpack_public_path__ + "static/ses-2021-working-in-the-public-interest-836271d084fc010c130641e63cf272e0.pdf";